import { useTranslation } from "react-i18next";

import { ColorPicker } from "@app/dashboard/components/inner_layout/ColorPicker";
import { useCheckoutCustomizationStore } from "@app/dashboard/store/checkout-customization";
import { useLangStore } from "@app/dashboard/store/lang";
import { CUSTOMIZATION_SECTIONS_KEYS } from "../../../../utils";
import { Title } from "../../../../components/Title";
import styles from "./brand-colors.module.scss";

const {
  ACCENT_COLOR,
  ACTION_COLOR
} = CUSTOMIZATION_SECTIONS_KEYS;

export const BrandColors = () => {
  const { t } = useTranslation();
  const { lang } = useLangStore();

  const {
    isFetched,
    setErrors,
    customizationData,
    setCustomizationData
  } = useCheckoutCustomizationStore();
  const { branding } = customizationData;
  const { colors } = branding;

  const colorInputs = isFetched ? [
    {
      label: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.brandColors.backgroundLabel'),
      name: ACCENT_COLOR,
      placeholder: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.brandColors.placeholders.color'),
      defaultValue: colors.accent
    },
    {
      label: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.brandColors.buttonLabel'),
      name: ACTION_COLOR,
      placeholder: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.brandColors.placeholders.color'),
      defaultValue: colors.action
    },
  ] : [];

  const handleChange = (name: string, color: string) => {
    setCustomizationData(prevData => ({
      ...prevData,
      branding: {
        ...prevData.branding,
        colors: {
          ...colors,
          [name]: color
        }
      }
    }));
  };

  return (
    <div className={styles["brand-colors"]}>
      <Title
        label={t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.brandColors.title')}
      />

      <div className={styles["brand-colors__main"]}>

        {
          colorInputs?.map((input, index) =>
            <ColorPicker
              key={`brand-colors-${input.label}-${index}`}
              lang={lang}
              label={input.label}
              defaultColor={input.defaultValue}
              inputProps={{
                name: input.name,
                placeholder: input.placeholder
              }}
              onErrorHandler={(errorMsg) => setErrors(input.name, errorMsg)}
              onColorChangeHandler={(color) => handleChange(input.name, color)}
            />
          )
        }

      </div>
    </div>
  )
};